<template>
	<div class="row dynvibeRow">
		<div class="col-lg-12">
			<div class="col-lg-12 dynvibeBox recently">
				<div class="col-lg-12">
					<div class="col-lg-12 dynvibeTitleBox"><h2>Recenlty Added Mastertags</h2></div>
				</div>
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading && noData" class="noData">
					<p>No Data to display</p>
				</div>
				<div class="col-lg-12" v-if="!loading && !noData">
					<div v-for="index in parseInt(data.length / 3) + 1" :key="index" style="min-height: 0px">
						<div
							v-if="data[(index - 1) * 3] || data[(index - 1) * 3 + 1] || data[(index - 1) * 3 + 2]"
							class="row vertical-divider"
						>
							<div v-if="data[(index - 1) * 3]" class="col-lg-4" @click="clicked(data[(index - 1) * 3].key)">
								<div class="group-info">
									<div v-for="(country, index1) in data[(index - 1) * 3].countries.buckets" :key="index1">
										<div
											v-if="country.key != ''"
											class="dynvibeRecentCountry"
											:style="'background-color:' + adjust(country.doc_count, index1)"
										>
											{{ country.key }}
										</div>
									</div>
								</div>
								<br />
								<div v-if="data[(index - 1) * 3].top_hits.hits.hits[0]._source.mastertags.length > 0">
									<div
										class="group-info"
										v-for="(archi, index2) in data[(index - 1) * 3].top_hits.hits.hits[0]._source.mastertags"
										:key="index2"
									>
										<div v-if="archi.label == data[(index - 1) * 3].key">
											<div v-for="(mastertag, index3) in unique(archi.archi)" :key="index3">
												<div class="dynvibeRecentCat">{{ mastertag.cat }}</div>
												<div
													class="dynvibeRecentSubCat"
													v-for="(subcat, index4) in mastertag.subcats"
													:key="index4"
												>
													{{ subcat }}
												</div>
												<div v-if="mastertag.trends != undefined" class="dynvibeRecentSubCat">
													{{ mastertag.trends }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<h2 class="mastertag">{{ data[(index - 1) * 3].key }}</h2>

								<div class="variation">
									<span
										v-if="
											variation(
												data[(index - 1) * 3].date_range.buckets[0].doc_count,
												data[(index - 1) * 3].date_range.buckets[1].doc_count
											) != undefined &&
											variation(
												data[(index - 1) * 3].date_range.buckets[0].doc_count,
												data[(index - 1) * 3].date_range.buckets[1].doc_count
											) > 0
										"
									>
										<span style="color: #33d1cd">
											<span class="dynvibeEvolutionIcon icon-arrow-growth"></span>
											<span class="dynvibeEvolutionVal"
												>{{
													Math.round(
														variation(
															data[(index - 1) * 3].date_range.buckets[0].doc_count,
															data[(index - 1) * 3].date_range.buckets[1].doc_count
														)
													)
												}}%</span
											>
										</span>
									</span>
									<span
										v-else-if="
											variation(
												data[(index - 1) * 3].date_range.buckets[0].doc_count,
												data[(index - 1) * 3].date_range.buckets[1].doc_count
											) != undefined &&
											variation(
												data[(index - 1) * 3].date_range.buckets[0].doc_count,
												data[(index - 1) * 3].date_range.buckets[1].doc_count
											) < 0
										"
									>
										<span style="color: #f04b3a">
											<span class="dynvibeEvolutionIcon icon-arrow-descent"></span>
											<span class="dynvibeEvolutionVal"
												>{{
													Math.round(
														variation(
															data[(index - 1) * 3].date_range.buckets[0].doc_count,
															data[(index - 1) * 3].date_range.buckets[1].doc_count
														)
													)
												}}%</span
											>
										</span>
									</span>
									<span v-else>
										<span style="color: grey"> - </span>
									</span>
								</div>
								<h3 class="date">Added : {{ getAddedDate(data[(index - 1) * 3].key) }}</h3>
							</div>
							<div v-if="data[(index - 1) * 3 + 1]" class="col-lg-4" @click="clicked(data[(index - 1) * 3 + 1].key)">
								<div class="group-info">
									<div v-for="(country, index1) in data[(index - 1) * 3 + 1].countries.buckets" :key="index1">
										<div
											v-if="country.key != ''"
											class="dynvibeRecentCountry"
											:style="'background-color:' + adjust(country.doc_count, index1)"
										>
											{{ country.key }}
										</div>
									</div>
								</div>
								<br />
								<div v-if="data[(index - 1) * 3 + 1].top_hits.hits.hits[0]._source.mastertags.length > 0">
									<div
										class="group-info"
										v-for="(archi, index2) in data[(index - 1) * 3 + 1].top_hits.hits.hits[0]._source.mastertags"
										:key="index2"
									>
										<div v-if="archi.label === data[(index - 1) * 3 + 1].key">
											<div v-for="(mastertag, index3) in unique(archi.archi)" :key="index3">
												<div class="dynvibeRecentCat">{{ mastertag.cat }}</div>
												<div
													class="dynvibeRecentSubCat"
													v-for="(subcat, index4) in mastertag.subcats"
													:key="index4"
												>
													{{ subcat }}
												</div>
												<div v-if="mastertag.trends != undefined" class="dynvibeRecentSubCat">
													{{ mastertag.trends }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<h2 class="mastertag">{{ data[(index - 1) * 3 + 1].key }}</h2>

								<div class="variation">
									<span
										v-if="
											variation(
												data[(index - 1) * 3 + 1].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 1].date_range.buckets[1].doc_count
											) != undefined &&
											variation(
												data[(index - 1) * 3 + 1].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 1].date_range.buckets[1].doc_count
											) > 0
										"
									>
										<span style="color: #33d1cd">
											<span class="dynvibeEvolutionIcon icon-arrow-growth"></span>
											<span class="dynvibeEvolutionVal"
												>{{
													Math.round(
														variation(
															data[(index - 1) * 3 + 1].date_range.buckets[0].doc_count,
															data[(index - 1) * 3 + 1].date_range.buckets[1].doc_count
														)
													)
												}}%</span
											>
										</span>
									</span>
									<span
										v-else-if="
											variation(
												data[(index - 1) * 3 + 1].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 1].date_range.buckets[1].doc_count
											) != undefined &&
											variation(
												data[(index - 1) * 3 + 1].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 1].date_range.buckets[1].doc_count
											) < 0
										"
									>
										<span style="color: #f04b3a">
											<span class="dynvibeEvolutionIcon icon-arrow-descent"></span>
											<span class="dynvibeEvolutionVal"
												>{{
													Math.round(
														variation(
															data[(index - 1) * 3 + 1].date_range.buckets[0].doc_count,
															data[(index - 1) * 3 + 1].date_range.buckets[1].doc_count
														)
													)
												}}%</span
											>
										</span>
									</span>
									<span v-else>
										<span style="color: grey"> - </span>
									</span>
								</div>
								<h3 class="date">Added : {{ getAddedDate(data[(index - 1) * 3 + 1].key) }}</h3>
							</div>
							<div v-if="data[(index - 1) * 3 + 2]" class="col-lg-4" @click="clicked(data[(index - 1) * 3 + 2].key)">
								<div class="group-info">
									<div v-for="(country, index1) in data[(index - 1) * 3 + 2].countries.buckets" :key="index1">
										<div
											v-if="country.key != ''"
											class="dynvibeRecentCountry"
											:style="'background-color:' + adjust(country.doc_count, index1)"
										>
											{{ country.key }}
										</div>
									</div>
								</div>
								<br />
								<div v-if="data[(index - 1) * 3 + 2].top_hits.hits.hits[0]._source.mastertags.length > 0">
									<div
										class="group-info"
										v-for="(archi, index2) in data[(index - 1) * 3 + 2].top_hits.hits.hits[0]._source.mastertags"
										:key="index2"
									>
										<div v-if="archi.label == data[(index - 1) * 3 + 2].key">
											<div v-for="(mastertag, index3) in unique(archi.archi)" :key="index3">
												<div class="dynvibeRecentCat">{{ mastertag.cat }}</div>
												<div
													class="dynvibeRecentSubCat"
													v-for="(subcat, index4) in mastertag.subcats"
													:key="index4"
												>
													{{ subcat }}
												</div>
												<div v-if="mastertag.trends != undefined" class="dynvibeRecentSubCat">
													{{ mastertag.trends }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<h2 class="mastertag">{{ data[(index - 1) * 3 + 2].key }}</h2>

								<div class="variation">
									<span
										v-if="
											variation(
												data[(index - 1) * 3 + 2].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 2].date_range.buckets[1].doc_count
											) != undefined &&
											variation(
												data[(index - 1) * 3 + 2].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 2].date_range.buckets[1].doc_count
											) > 0
										"
									>
										<span style="color: #33d1cd">
											<span class="dynvibeEvolutionIcon icon-arrow-growth"></span>
											<span class="dynvibeEvolutionVal"
												>{{
													Math.round(
														variation(
															data[(index - 1) * 3 + 2].date_range.buckets[0].doc_count,
															data[(index - 1) * 3 + 2].date_range.buckets[1].doc_count
														)
													)
												}}%</span
											>
										</span>
									</span>
									<span
										v-else-if="
											variation(
												data[(index - 1) * 3 + 2].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 2].date_range.buckets[1].doc_count
											) != undefined &&
											variation(
												data[(index - 1) * 3 + 2].date_range.buckets[0].doc_count,
												data[(index - 1) * 3 + 2].date_range.buckets[1].doc_count
											) < 0
										"
									>
										<span style="color: #f04b3a">
											<span class="dynvibeEvolutionIcon icon-arrow-descent"></span>
											<span class="dynvibeEvolutionVal"
												>{{
													Math.round(
														variation(
															data[(index - 1) * 3 + 2].date_range.buckets[0].doc_count,
															data[(index - 1) * 3 + 2].date_range.buckets[1].doc_count
														)
													)
												}}%</span
											>
										</span>
									</span>
									<span v-else>
										<span style="color: grey"> - </span>
									</span>
								</div>
								<h3 class="date">Added : {{ getAddedDate(data[(index - 1) * 3 + 2].key) }}</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "RecentlyAdded",
	props: {
		type: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {};
			},
		},
		country: {
			type: Array,
			default: function () {
				return [];
			},
		},
		sources: {
			type: Array,
			default: function () {
				return [];
			},
		},
		age: {
			type: Array,
			default: function () {
				return [];
			},
		},
		gender: {
			type: Array,
			default: function () {
				return [];
			},
		},
		category: {
			type: String,
			default: "",
		},
		subcategory: {
			type: String,
			default: "",
		},
		mastertag: {
			type: String,
			default: "",
		},
		trend: {
			type: String,
			default: "",
		},
		typemastertag: {
			type: String,
			default: "All",
		},
	},
	data() {
		return {
			loading: true,
			noData: false,
			data: {},
			front: false,
			mastertags: [],
		};
	},
	mounted: function () {
		this.getData("getRecenltyAddedMastertag", {
			data: {
				type: this.typemastertag,
				level: "categories",
			},
			parameters: {
				panel: this.panel,
				segment: this.segment,
				date: this.date,
				country: this.country,
				category: this.category,
				subcategory: this.subcategory,
				mastertag: this.mastertag,
				trend: this.trend,
				typemastertag: this.typemastertag,
				age: this.age,
				gender: this.gender,
				sources: this.sources,
			},
		});
	},
	methods: {
		checkFilters() {
			if (this.date.gte === "") {
				return;
			}
			let level = "categories";
			if (this.category != "") {
				level = "subcategories";
			}
			if (this.subcategory != "") {
				level = "mastertag";
			}
			if (this.trend != "") {
				level = "trends";
			}
			this.hidden = false;
			this.loading = true;

			this.getData("getRecenltyAddedMastertag", {
				data: {
					type: this.typemastertag,
					level: level,
				},
				parameters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					mastertag: this.mastertag,
					trend: this.trend,
					typemastertag: this.typemastertag,
					age: this.age,
					gender: this.gender,
					sources: this.sources,
				},
			});
		},
		getAddedDate(mastertag) {
			if (this.mastertags.find((element) => element.label == mastertag) == undefined) {
				return false;
			} else {
				return this.mastertags.find((element) => element.label == mastertag).added.split("T")[0];
			}
		},
		unique(arr) {
			return arr.filter((v, i, a) => a.findIndex((t) => JSON.stringify(t) === JSON.stringify(v)) === i);
		},
		clicked(item) {
			this.$emit("clicked", { keyword: item, level: "mastertag" });
		},
		treatResponse(response) {
			this.loading = false;
			this.mastertags = response.data.mastertags;
			this.data = this.format(response.data.data);
			let newMastertag = false;
			this.data.forEach((element) => {
				newMastertag = this.getAddedDate(element.key);
			});
			this.noData = this.data.length === 0 || !newMastertag ? true : false;
		},
		format(data) {
			let indexToRemove = [];
			for (let index = 0; index < data.length; index++) {
				if (this.getAddedDate(data[index].key) === false) {
					indexToRemove.push(index);
				}
			}
			for (let index = 0; index < indexToRemove.length; index++) {
				delete data[indexToRemove[index]];
			}
			return data.filter(function (element) {
				return element !== undefined;
			});
		},
		variation(start, end) {
			let startValue = start == 0 ? 1 : start;
			return ((end - startValue) / startValue) * 100;
		},
		adjust(color, amount) {
			switch (amount) {
				case 2:
					return "#dadada";
				case 1:
					return "#dadada";
				case 0:
					return "rgba(35, 5, 107, 0.7)";
			}
		},
	},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date: {
			deep: true,
			handler() {
				this.checkFilters();
			},
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
	},
};
</script>

<style scoped>
.dynvibeEvolutionIcon {
	margin-left: 5px;
	margin-right: 4px;
	font-size: 25px;
}

.dynvibeEvolutionVal {
	font-family: "Montserrat";
}
.row.vertical-divider {
	/*overflow: hidden;*/
	height: 250px;
}
.row.vertical-divider > div[class^="col-"] {
	text-align: center;
	border-right: 1px solid #979595;
	height: 100%;
}
.row.vertical-divider div[class^="col-"]:first-child {
	border-left: none;
}
.row.vertical-divider div[class^="col-"]:last-child {
	border-right: none;
}
.group-info {
	display: inline-block;
	margin-left: 1px;
	float: left;
	width: 100%;
}
.mastertag {
	display: inline-block;
	margin-right: 375px;
	text-align: left;
	width: 100%;
	cursor: pointer;
}
.date {
	display: inline-block;
	margin-top: 10%;
	margin-right: 407px;
	line-height: 1;
	font-size: 14px;
	font-weight: 700;
	text-transform: uppercase;
	width: 100%;
}
.variation {
	text-align: right;
	font-size: 2em;
	width: 100%;
	vertical-align: center;
}
.column {
	display: inline-block;
	width: 200px;
	height: 100px;
	margin: 1em;
}
.recenBox {
	/*overflow: hidden;
	min-height: 151px;
	padding: 26px;*/
	background-color: #fff;
	box-shadow: 1px 1px 3px rgb(0 0 0 / 25%);
}
.dynvibeRecentCountry {
	display: inline-block;
	margin: 0px 3px 3px 0px;
	float: left;
	padding: 3px 10px;
	font-family: "Montserrat";
	font-weight: 500;
	text-transform: uppercase;
	text-align: center;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	min-width: 80px;
	background-color: blue;
	color: #fff;
	font-size: 1em;
}
.dynvibeRecentCat {
	display: inline-block;
	margin: 0px 3px 3px 0px;
	float: left;
	padding: 3px 10px;
	font-family: "Montserrat";
	font-weight: 500;
	text-transform: uppercase;
	text-align: center;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	min-width: 80px;
	background-color: rgb(239, 64, 46);
	color: #fff;
	font-size: 1em;
}
.dynvibeRecentSubCat {
	display: inline-block;
	margin: 0px 3px 3px 0px;
	float: left;
	padding: 3px 10px;
	font-family: "Montserrat";
	font-weight: 500;
	text-transform: uppercase;
	text-align: center;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	min-width: 80px;
	background-color: #33d1cd;
	color: #fff;
	font-size: 1em;
}
.dynvibeRecentTrend {
	display: inline-block;
	margin: 0px 3px 3px 0px;
	float: left;
	padding: 3px 10px;
	font-family: "Montserrat";
	font-weight: 500;
	text-transform: uppercase;
	text-align: center;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	min-width: 80px;
	background-color: yellow;
	color: #fff;
	font-size: 1em;
}
.recently {
	min-height: 350px;
	margin-bottom: 100px;
}
</style>
